import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import AbsenceBanner from "@/components/AbsenceBanner";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import ZoneMap from "@/components/ZoneMap";
import Pricing from "@/components/Pricing";
import BookingForm from "@/components/BookingForm";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

export default function Home() {
  const [absence, setAbsence] = useState(null);

  useEffect(() => {
    api
      .get("/settings/absence")
      .then(({ data }) => setAbsence(data))
      .catch(() => setAbsence(null));
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      {absence?.active && <AbsenceBanner start={absence.start} end={absence.end} />}
      <main>
        <Hero />
        <Marquee />
        <Services />
        <HowItWorks />
        <ZoneMap />
        <Pricing />
        <BookingForm />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
    </>
  );
}
